import React, { Component, useState } from "react";
import _ from 'lodash';
import moment from 'moment';
import { Row } from "components/shared/layout";
import CvCard from "components/cv-card";
import TaskBanner from "pages/opportunities/view/components/banner";
import { CvCardWrapper, Container, CardTitleContainer, LevelSelect } from "./styles";
import { businessInformationQuestions, financeQuestions, marketingQuestions, staffingQuestions, ITQuestions } from './questions';
import { navigate } from "@reach/router";
import DashboardProvider from "containers/dashboard";
import { Provider, Subscribe } from "unstated";
import { longDate } from "utils/dateFormats";
import { v4 as uuidv4 } from "uuid";
import { Select } from 'antd';
import TawkTo from 'tawkto-react'

const { Option } = Select;

const BusinessOverview = ({ data, isLoading }) => (
  <CvCardWrapper key={uuidv4()} xs={12}>
    <CvCard
      header={{
        title: "Business Overview",
        subtitle: (
          <>
            <span>
              {_.get(data, 'team_members.length', 0)}
              {' '}
              team members
            </span>
            <br/>
            <span>
              {_.get(data, 'business_description', 'Provide a short summary about your business')}
            </span>
          </>
        ),
        onAddClick: () => navigate("/biz-profile/business-overview", { state: { data }}),
        divider: false,
        btnEditInd: !!data && !!data.business_description,
      }}
      style={{ height: "auto" }}
      isLoading={isLoading}
    />
  </CvCardWrapper>
);

const BusinessInformationPanel = ({ data, isLoading, taskStatuses }) => {
  const [level, setLevel] = useState(1);

  return (
    <CvCardWrapper key={uuidv4()} xs={12} xl={6}>
      <CvCard
        header={{
          title: (
            <>
              <span>Business Information</span>
              <br></br>
              <span>500 Zlto</span>
              <LevelSelect defaultValue={level} onChange={setLevel}>
                <Option value={1}>Level 1</Option>
                <Option value={2}>Level 2</Option>
              </LevelSelect>
            </>
          ),
          count: _.size(data),
          onAddClick: () => navigate('/biz-profile/business-information/add', { state: { data, taskStatuses, level } }),
          variant: taskStatuses[level]?.is_credited ? 'primary' : "lightBlue",
          isApproved: taskStatuses[level]?.is_credited
        }}
        rows={_.map(_.pick(data, _.keys(businessInformationQuestions[level])), (obj, key) => {
            return {
              title: _.startCase(key),
              subtitle: moment(obj.timestamp).format('l @ LT'),
              onViewClick: () =>
                navigate(`/biz-profile/business-information/add`, { state: { data, taskStatuses, level } }),
            };
          }
        )}
        isLoading={isLoading}
        emptyMessage={"You have not added any Business Information data about your business"}
      />
    </CvCardWrapper>
  );
};

const MarketingPanel = ({ data, isLoading, taskStatuses }) => {
  const [level, setLevel] = useState(1);

  return (
    <CvCardWrapper key={uuidv4()} xs={12} xl={6}>
      <CvCard
        header={{
          title: (
            <>
              <span>Marketing</span>
              <br></br>
              <span>500 Zlto</span>
              <LevelSelect defaultValue={level} onChange={setLevel}>
                <Option value={1}>Level 1</Option>
                <Option value={2}>Level 2</Option>
              </LevelSelect>
            </>
          ),
          count: _.size(data),
          onAddClick: () => navigate('/biz-profile/marketing/add', { state: { data, taskStatuses, level } }),
          variant: taskStatuses[level]?.is_credited ? 'primary' : "lightBlue",
          isApproved: taskStatuses[level]?.is_credited
        }}
        rows={_.map(_.pick(data, _.keys(marketingQuestions[level])), (obj, key) => {
            return {
              title: _.startCase(key),
              subtitle: moment(obj.timestamp).format('l @ LT'),
              onViewClick: () =>
                navigate(`/biz-profile/marketing/add`, { state: { data, taskStatuses, level } }),
            };
          }
        )}
        isLoading={isLoading}
        emptyMessage={"You have not added any Marketing data about your business"}
      />
    </CvCardWrapper>
  );
}

const FinancePanel = ({ data, isLoading, taskStatuses }) => {
  const [level, setLevel] = useState(1);

  return (
    <CvCardWrapper key={uuidv4()} xs={12} xl={6}>
      <CvCard
        header={{
          title: (
            <>
              <span>Finance</span>
              <br></br>
              <span>500 Zlto</span>
              <LevelSelect defaultValue={level} onChange={setLevel}>
                <Option value={1}>Level 1</Option>
                <Option value={2}>Level 2</Option>
              </LevelSelect>
            </>
          ),
          count: _.size(data),
          onAddClick: () => navigate('/biz-profile/finance/add', { state: { data, taskStatuses, level } }),
          variant: taskStatuses[level]?.is_credited ? 'primary' : "lightBlue",
          isApproved: taskStatuses[level]?.is_credited
        }}
        rows={_.map(_.pick(data, _.keys(financeQuestions[level])), (obj, key) => {
            return {
              title: _.startCase(key),
              subtitle: moment(obj.timestamp).format('l @ LT'),
              onViewClick: () =>
                navigate(`/biz-profile/finance/add`, { state: { data, taskStatuses, level } }),
            };
          }
        )}
        isLoading={isLoading}
        emptyMessage={"You have not added any Finance data about your business"}
      />
    </CvCardWrapper>
  );
};

const StaffingPanel = ({ data, isLoading, taskStatuses }) => {
  const [level, setLevel] = useState(1);

  return (
    <CvCardWrapper key={uuidv4()} xs={12} xl={6}>
      <CvCard
        header={{
          title: (
            <>
              <span>Staffing</span>
              <br></br>
              <span>500 Zlto</span>
              <LevelSelect defaultValue={level} onChange={setLevel}>
                <Option value={1}>Level 1</Option>
                <Option value={2}>Level 2</Option>
              </LevelSelect>
            </>
          ),
          count: _.size(data),
          onAddClick: () => navigate('/biz-profile/staffing/add', { state: { data, taskStatuses, level } }),
          variant: taskStatuses[level]?.is_credited ? 'primary' : "lightBlue",
          isApproved: taskStatuses[level]?.is_credited
        }}
        rows={_.map(_.pick(data, _.keys(staffingQuestions[level])), (obj, key) => {
            return {
              title: _.startCase(key),
              subtitle: moment(obj.timestamp).format('l @ LT'),
              onViewClick: () =>
                navigate(`/biz-profile/staffing/add`, { state: { data, taskStatuses, level } }),
            };
          }
        )}
        isLoading={isLoading}
        emptyMessage={"You have not added any Staffing data about your business"}
      />
    </CvCardWrapper>
  );
};


const OperationalManagementPanel = ({ data, isLoading, taskStatus }) => {
  const [level, setLevel] = useState(1);

  return (
    <CvCardWrapper key={uuidv4()} xs={12} xl={6}>
      <CvCard
        header={{
            title: (
              <>
                <span>Operational Management</span>
                <br></br>
              <span>500 Zlto</span>
                <LevelSelect defaultValue={level} onChange={setLevel}>
                  <Option value={1}>Level 1</Option>
                  <Option value={2}>Level 2</Option>
                </LevelSelect>
              </>
            ),
          count: _.size(data),
          onAddClick: () => navigate("/biz-profile/operational-management/add", { state: { data, taskStatus, level }}),
          variant: taskStatus?.is_credited ? 'primary' : "lightBlue",
          isApproved: taskStatus?.is_credited
        }}
        rows={_.map(data, (obj, key) => {
            return {
              title: _.startCase(key),
              subtitle: moment(obj.timestamp).format('l @ LT'),
              onViewClick: () =>
                navigate(`/biz-profile/operational-management/add`, { state: { data, taskStatus }}),
            };
          }
        )}
        isLoading={isLoading}
        emptyMessage={"You have not added any Operational Management data about your business"}
      />
    </CvCardWrapper>
  )
};

const ITPanel = ({ data, isLoading, taskStatuses }) => {
  const [level, setLevel] = useState(1);

  return (
    <CvCardWrapper key={uuidv4()} xs={12} xl={6}>
      <CvCard
        header={{
          title: (
            <>
              <span>Information Technology</span>
              <br></br>
              <span>500 Zlto</span>
              <LevelSelect defaultValue={level} onChange={setLevel}>
                <Option value={1}>Level 1</Option>
                <Option value={2}>Level 2</Option>
              </LevelSelect>
            </>
          ),
          count: _.size(data),
          onAddClick: () => navigate('/biz-profile/information-technology/add', { state: { data, taskStatuses, level } }),
          variant: taskStatuses[level]?.is_credited ? 'primary' : "lightBlue",
          isApproved: taskStatuses[level]?.is_credited
        }}
        rows={_.map(_.pick(data, _.keys(ITQuestions[level])), (obj, key) => {
            return {
              title: _.startCase(key),
              subtitle: moment(obj.timestamp).format('l @ LT'),
              onViewClick: () =>
                navigate(`/biz-profile/information-technology/add`, { state: { data, taskStatuses, level } }),
            };
          }
        )}
        isLoading={isLoading}
        emptyMessage={"You have not added any Information Technology data about your business"}
      />
    </CvCardWrapper>
  );
};

const getDateSubtitle = (startDate, endDate) => {
  if (startDate && endDate) {
    return `${longDate(startDate)} - ${longDate(endDate)}`;
  } else if (startDate && !endDate) {
    return longDate(startDate);
  } else if (!startDate && endDate) {
    return longDate(endDate);
  }
  return "";
};

const Dashboard = ({ ...props }) => {
  const {
    requirements,
    requirementsIsLoading,
    taskStatuses
  } = { ...props.state };

  console.log('@@@@ requirements: ', requirements);
  console.log('@@@@ taskStatuses: ', taskStatuses);

  const {
    business_overview,
    business_information,
    finance,
    staffing,
    marketing,
    operational_management,
    information_technology
  } = requirements;

  return (
    <Container>
      <Row>
        <CvCardWrapper key={uuidv4()} xs={12} xl={6}>
          <TaskBanner onRedeem={() => navigate('/biz-profile')} />
        </CvCardWrapper>
        <BusinessOverview
          data={business_overview}
          isLoading={requirementsIsLoading}
        />
        <BusinessInformationPanel
          data={business_information}
          isLoading={requirementsIsLoading}
          taskStatuses={{ 
            1: taskStatuses.businessInformationLevel1,
            2: taskStatuses.businessInformationLevel2,
          }}
        />
        <FinancePanel
          data={finance}
          isLoading={requirementsIsLoading}
          taskStatuses={{ 
            1: taskStatuses.financeLevel1,
            2: taskStatuses.financeLevel2,
          }}
        />
        <StaffingPanel
          data={staffing}
          isLoading={requirementsIsLoading}
          taskStatuses={{ 
            1: taskStatuses.staffingLevel1,
            2: taskStatuses.staffingLevel2,
          }}
        />
        <MarketingPanel
          data={marketing}
          isLoading={requirementsIsLoading}
          taskStatuses={{ 
            1: taskStatuses.marketingLevel1,
            2: taskStatuses.marketingLevel2,
          }}
        />
        <OperationalManagementPanel
          data={operational_management}
          isLoading={requirementsIsLoading}
          taskStatus={taskStatuses.operationalManagement}
        />
        <ITPanel
          data={information_technology}
          isLoading={requirementsIsLoading}
          taskStatuses={{ 
            1: taskStatuses.informationTechnologyLevel1,
            2: taskStatuses.informationTechnologyLevel2,
          }}
        />
        <CvCardWrapper xs={6} />
      </Row>
    </Container>
  );
};

class DashboardConsumer extends Component {
  constructor() {
    super();
    this.state = {
      provider: new DashboardProvider(),
    };
  }
  componentWillMount() {
    this.state.provider.loadDashboardData();
  }

  componentDidMount()
  {
      var tawk = new TawkTo('61fa8f04b9e4e21181bd1db0', '1fqtbtbbp')
  }

  render() {
    return (
      <Provider>
        <Subscribe to={[this.state.provider]}>
          {(props) => <Dashboard {...props} />}
        </Subscribe>
      </Provider>
    );
  }
}
export default DashboardConsumer;
